import template from './apiaccesslog-list.html';
import controller from './apiaccesslog-list.controller';

let apiaccesslogListComponent = {
  bindings: {},
  template,
  controller
};

export default apiaccesslogListComponent;



// WEBPACK FOOTER //
// ./client/app/components/apiaccesslog/apiaccesslog-list.component.js